import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import FlipMove from "react-flip-move";
import styles from "../index.module.css";
import ListItem from "./ListItem";
import ActivePlayerItem from "./ActivePlayerItem";
import { useTimer } from "../hooks/Timer";
import { useFetchLeaderboard } from "../hooks/Api-hooks";
import { usePrevious } from "../hooks/PreviousState";

function Leaderboard(props) {
  let location = useLocation();

  let urlParams = new URLSearchParams(location.search);
  const isIceEvent = process.env.REACT_APP_ICE === "ICE";
  const nocontrols = urlParams.get("nocontrols");

  const [newPlayers, setNewPLayers] = useState([]);

  const { competition } = props;
  const [leaderboard, , fetchLeaderboard] = useFetchLeaderboard();
  const [recentPlayers, , fetchRecentPlayers] = useFetchLeaderboard();

  const timer = useTimer(competition);

  const prevPlayers = usePrevious(recentPlayers.data);

  useEffect(() => {
    if (!recentPlayers.data || !prevPlayers.data) return;
    if (JSON.stringify(prevPlayers) !== JSON.stringify(recentPlayers)) {
      const result = recentPlayers.filter(
        o1 => !prevPlayers.some(o2 => o1.accountId === o2.accountId)
      );
      setNewPLayers(result);
    }
  }, [recentPlayers, prevPlayers]);
  useEffect(()=> {
    fetchLeaderboard(
      `/competition/competitions/${props.competition.id}/leaderboard`,
      props.currentOperator.id
    );
    fetchRecentPlayers(
      `/competition/competitions/${props.competition.id}/recentPlayers`,
      props.currentOperator.id
    );
  },[props.currentOperator.id, props.competition.id])
  useEffect(() => {
    let interval = setInterval(() => {
      fetchLeaderboard(
        `/competition/competitions/${props.competition.id}/leaderboard`,
        props.currentOperator.id
      );
      fetchRecentPlayers(
        `/competition/competitions/${props.competition.id}/recentPlayers`,
        props.currentOperator.id
      );
    }, 5000);
    return () => clearInterval(interval);
  },[props.currentOperator.id, props.competition.id]);

  function toggleDocumentFullScreen() {
    if (!isIceEvent) return;
    let doc = window.document;
    let docEl = doc.body;
    let requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;
    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      requestFullScreen.call(docEl);
    }
  }

  return (
    <div
      className={`${styles.leaderboardContainer} root`}
      onClick={e => toggleDocumentFullScreen()}
    >
      <div
        className={styles.leaderboardImage}
        style={{
          backgroundImage: `url(${require(`./../img/PortraitLeaderboard-${props.competition.template.gameId}.jpg`)}`
          // backgroundImage: `url(${require(`./../img/PortraitLeaderBoard-10041.png`)}`
        }}
      >
        {<h1 className={styles.timer}>{competition.state.current === 'FINISHED' ?'Competition ended' :timer}</h1>}

        <h1
          className={
            isIceEvent ? styles.ice_highscoreTitle : styles.highscoreTitle
          }
        >
          Highscore
        </h1>

        <div
          className={
            isIceEvent
              ? styles.ice_highscoreContainer
              : styles.highscoreContainer
          }
        >
          <FlipMove
            typeName="ul"
            easing={"ease-in"}
            className={styles.highscoreList}
            duration={750}
            // staggerDelayBy={200}
          >
            {leaderboard
              ? leaderboard.slice(0, 10).map(player => (
                  <div key={player.accountId}>
                    <ListItem player={player} />
                  </div>
                ))
              : null}
          </FlipMove>
        </div>
        <h1
          className={
            isIceEvent
              ? styles.ice_activeplayersTitle
              : styles.activeplayersTitle
          }
        >{`Active players`}</h1>
        <div
          className={
            isIceEvent
              ? styles.ice_activeplayersTitlesContainer
              : styles.activeplayersTitlesContainer
          }
        >
          <div className={styles.activeplayersNameTitle}>NAME</div>
          <div className={styles.activeplayersHighscoreTitle}>HIGHEST</div>
          <i className={`fa fa-repeat ${styles.activeplayersSpinTitle}`} />
          <div className={styles.activeplayersScoreTitle}>POINTS</div>
        </div>
        <div
          className={
            isIceEvent
              ? styles.ice_activeplayersContainer
              : styles.activeplayersContainer
          }
        >
          <FlipMove
            typeName="ul"
            className={styles.activeplayersList}
            easing={"ease-in"}
            duration={750}
          >
            {recentPlayers
              ? recentPlayers
                  .sort(
                    (a, b) => Date.parse(b.scoreDate) - Date.parse(a.scoreDate)
                  )
                  .sort((c, d) => d.score - c.score)
                  .slice(0, 10)
                  .map(player => (
                    <div key={player.accountId}>
                      <ActivePlayerItem player={player} />
                    </div>
                  ))
              : null}
            {newPlayers.slice(0, 2).map(p => (
              <div className={`${styles.newPlayers}`} key={p.accountId}>
                {`${p.screenName} joined the competition`}
              </div>
            ))}
          </FlipMove>
        </div>
        {!isIceEvent && nocontrols !== "true" && (
          <Link to={"/"} className={styles.arrowLeft}>
            &#8592;
          </Link>
        )}
      </div>
    </div>
  );
}
export default Leaderboard;

//  (${recentPlayers ? recentPlayers.length : ""})